import { render, staticRenderFns } from "./FormSignUp.vue?vue&type=template&id=006ce19c&scoped=true&"
import script from "./FormSignUp.vue?vue&type=script&lang=js&"
export * from "./FormSignUp.vue?vue&type=script&lang=js&"
import style0 from "./FormSignUp.vue?vue&type=style&index=0&id=006ce19c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ce19c",
  null
  
)

export default component.exports